import { Transition_Child_default } from "./chunk-JAJRHTJ3.js";
import { Transition_default } from "./chunk-QAHAMZFY.js";

// src/elements/Transition/index.ts
var TransitionComponent = Transition_default;
TransitionComponent.Child = Transition_Child_default;
TransitionComponent.Child.displayName = "Transition.Child";
export { TransitionComponent };